import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { withStyles, Paper, TableContainer, Table } from "@material-ui/core";
import TableHeader from "./TableHeader";
import TableContent from "./TableContent";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import t from "../../../languages/pl";
import { bindActionCreators } from 'redux';
import ActionCreator from './../../../store/actions/index';
import ReportDetailsWithDrivers from './../ReportsDetailsDialog/ReportDetailsWithDrivers';
import ReportDetailsWithCars from './../ReportsDetailsDialog/ReportDetailsWithCars';
import TableContainerWithHeight from './../../Common/TableContainerWithHeight';
import PaperContainer from "../../Common/PaperContainer";

const AutomaticReports = props => {
    const { automaticReports, allDrivers, height } = props;
    const [report, setReport] = useState(null);
    const [deleteId, setDeleteId] = useState(null);

    useEffect(() => {
        props.getAutomaticReports();
    }, []);

    const handleSubmit = (automaticReport) => {
        props.putAutomaticReport(report.raport_id, automaticReport, report.typ);
    };

    return (
        <PaperContainer>
            {height &&
                <TableContainerWithHeight height={height}>
                    <Table stickyHeader>
                        <TableHeader />
                        <TableContent
                            reports={automaticReports}
                            onManageOpen={(id) => setReport(automaticReports.find(report => report.raport_id === id))}
                            onDelete={(id) => setDeleteId(id)}
                        />
                    </Table>
                </TableContainerWithHeight>
            }
            {
                report !== null
                &&
                (report.kierowcy ?
                    <ReportDetailsWithDrivers
                        title={report.typ}
                        report={report}
                        open={report !== null}
                        isEdit={true}
                        onClose={() => setReport(null)}
                        autoEnable={true}
                        availableDrivers={allDrivers}
                        option={report.wybor}
                        onSubmit={handleSubmit}
                    />
                    :
                    <ReportDetailsWithCars
                        title={report.typ}
                        report={report}
                        open={report !== null}
                        isEdit={true}
                        onClose={() => setReport(null)}
                        autoEnable={true}
                        onSubmit={handleSubmit}
                        onFileSubmit={props.postFile}
                    />
                )
            }
            {/* <ManageReportDialog
                data={report}
                onClose={() => setReport(null)}
            /> */}
            <ConfirmationDialog
                open={deleteId !== null}
                onClose={() => setDeleteId(null)}
                id={deleteId}
                onSubmit={(id) => props.deleteAutomaticReport(id)}
                action={t.deleteReportConfirmation}
            />
        </PaperContainer>
    );
};

const mapStateToProps = (state) => ({
    automaticReports: state.reportReducer.automaticReportList,
    allDrivers: state.driverReducer.availableDrivers
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


AutomaticReports.propTypes = {
    height: PropTypes.number,
    //redux
    automaticReports: PropTypes.array,
    allDrivers: PropTypes.array,
    deleteAutomaticReport: PropTypes.func,
    putAutomaticReport: PropTypes.func,
    postFile: PropTypes.func,
    getAutomaticReports: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomaticReports);

